import { createFileRoute } from '@tanstack/react-router'

import { DashboardPage } from '@/features/dashboard/components/DashboardPage'
import { setupSearchSchema } from '@/features/connect/setup'
import { groupsInfiniteQueryOptions } from '@/features/group/queries'

export const Route = createFileRoute('/_authed/dashboard')({
  validateSearch: setupSearchSchema,
  shouldReload: ({ cause }) => cause !== 'stay',
  loader: async ({ context }) => {
    // Query retains the error so the dashboard can render its own retry action.
    await context.queryClient.infiniteQuery(groupsInfiniteQueryOptions()).catch(() => undefined)
  },
  component: DashboardPage,
})
